import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { buildPublicExperienceStyles } from '../../../services/global.service';
import { ButtonModule } from 'primeng/button';
import { ProductDesignTemplatePageModuleDataContent } from '../../../store/app.model';

@Component({
  selector: 'app-downloadable-files',
  imports: [
    CommonModule,
    ButtonModule
  ],
  templateUrl: './downloadable-files.html',
})
export class DownloadableFiles {
  @Input({ required: true }) content!: any;
  @Input({ required: true }) styles!: any;
  @Input({ required: true }) isSelectedModule!: boolean;
  @Input({ required: true }) isFirstModule!: boolean;
  @Input({ required: true }) isLastModule!: boolean;

  
  items: ProductDesignTemplatePageModuleDataContent[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (this.content) {
      if (
        'pageModuleTemplateDataContents' in this.content &&
        Array.isArray(this.content.pageModuleTemplateDataContents)
      ) {
        this.items = this.content.pageModuleTemplateDataContents;
      } else if (
        'contentItems' in this.content &&
        Array.isArray(this.content.contentItems)
      ) {
        this.items = this.content.contentItems;
      } else if (
        'components' in this.content &&
        Array.isArray(this.content.components)
      ) {
        this.items = this.content.components;
      } else {
        this.items = [];
      }
    } else {
      this.items = [];
    }
  }

  buildStyle(type: string, style: any): string {
    return buildPublicExperienceStyles(type, style);
  }

  filter(array: any[] | undefined | null, column: any, value: any) {
    if (!array) return [];
    return array.filter(item => item[column] === value);
  }

  downloadFile(url: string) {
    if(url) {
      window.open(url, '_blank');
    }
  }
}
